export type MetadataResource = "beneficiary" | "title" | "term";

export const METADATA_PATH: Record<MetadataResource, string> = {
    beneficiary: "/settings/custom-beneficiary",
    title: "/settings/custom-title",
    term: "/settings/custom-term",
};

/** `/settings/metadata` and any unknown address open the title tab. */
export const metadataResourceFromPath = (pathname: string): MetadataResource => {
    const match = (Object.entries(METADATA_PATH) as [MetadataResource, string][]).find(([, path]) =>
        pathname.includes(path),
    );
    return match?.[0] ?? "title";
};

/**
 * Term uses the title permission. A forbidden tab falls back to the other one.
 */
export const metadataResourceForAccess = (
    requested: MetadataResource,
    canAccessTitle: boolean,
    canAccessBeneficiary: boolean,
): MetadataResource => {
    if (requested === "beneficiary") return canAccessBeneficiary ? "beneficiary" : "title";
    return canAccessTitle ? requested : "beneficiary";
};

export const metadataPermission = (resource: MetadataResource) =>
    resource === "beneficiary" ? "CustomBeneficiarySettings" : "CustomTitleSettings";
